<div [ngSwitch]="buttonField?.type">
    <div
        *ngSwitchCase="'onDemandPsvButton'"
        class="button-wrapper"
        container="body"
        placement="top"
        tooltipClass="max-200 text-left"
        [ngbTooltip]="buttonField.value.hoverText"
    >
        <button
            class="btn btn-primary"
            [disabled]="buttonField.value.isButtonDisabled"
            (click)="initiatePsv($event, registry)"
        >
            {{ buttonField.value.buttonText }}
        </button>
    </div>
    <div *ngSwitchCase="'onDemandPsvMessage'" class="message-wrapper">
        <span
            class="message-button"
            container="body"
            placement="top"
            tooltipClass="max-200 text-left"
            [ngbTooltip]="buttonField.value.hoverText"
            >{{ buttonField.value.message }}</span
        >
        <cm-option-dropdown
            *ngIf="buttonField.value.showDropdown"
            class="more-options"
            placement="bottom-right"
            [options]="moreOptions"
            [dropdownIcon]="'arrow-down-circle'"
            (optionChanged)="initiatePsv($event, registry)"
        ></cm-option-dropdown>
    </div>
</div>

<ng-template #errorTemplate>
    <div class="modal-body">
        <p>{{ ERROR_TEMPLATE_MESSAGE }}</p>
        <p *ngFor="let error of errorsArray">Error: {{ error.message }}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="closeChildModal()">Ok</button>
    </div>
</ng-template>
